var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Track",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 304.731,
    height: 280,
    viewBox: "0 0 304.731 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20628",
    "data-name": "Rectangle 20628",
    width: 304.731,
    height: 280,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20571",
    "data-name": "Rectangle 20571",
    width: 235.197,
    height: 235.633,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20584",
    "data-name": "Rectangle 20584",
    width: 13.45,
    height: 9.556,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20585",
    "data-name": "Rectangle 20585",
    width: 17.723,
    height: 12.592,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20586",
    "data-name": "Rectangle 20586",
    width: 21.996,
    height: 15.629,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20587",
    "data-name": "Rectangle 20587",
    width: 26.269,
    height: 18.665,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20621",
    "data-name": "Rectangle 20621",
    width: 65.882,
    height: 38.037,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20626",
    "data-name": "Rectangle 20626",
    width: 27.595,
    height: 27.594,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46813",
    "data-name": "Group 46813",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46643",
    "data-name": "Group 46643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46642",
    "data-name": "Group 46642",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75354",
    "data-name": "Path 75354",
    d: "M148.51,48.776c-2-.3-3.338-.946-3.6-2a2.72,2.72,0,0,1,1.66-2.84,8.887,8.887,0,0,1,4.315-.527c-.184-1.838,1.508-4.013,3.177-4.936s4.7-1.139,6.408.269c.495-3.3,2.613-4.909,5.931-6.063a8.683,8.683,0,0,1,8.5,1.635c1.923-3.6,7.652-5.75,13.537-3.4a10.212,10.212,0,0,1,5.307,4.965,11.41,11.41,0,0,1,.9,4.056,5.149,5.149,0,0,1,5.453-.265,4.232,4.232,0,0,1,1.986,3.807,10.867,10.867,0,0,1,3.532.82c1.276.534,2.6,1.734,2.138,2.992-.35.953-1.535,1.332-2.58,1.476a15.732,15.732,0,0,1-6.209-.387,11.139,11.139,0,0,1-12.679-.307,20.62,20.62,0,0,1-2.622,1.693,10.316,10.316,0,0,1-3.047.815c-1.778.192-4.279-.143-5.666-1.311a1.177,1.177,0,0,0-.66-.366,1.123,1.123,0,0,0-.565.2,8.242,8.242,0,0,1-8.675-.615,8.255,8.255,0,0,1-11.483-.464,9.118,9.118,0,0,1-5.056.76",
    transform: "translate(-54.577 -11.276)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75355",
    "data-name": "Path 75355",
    d: "M94.1,27.115c1.495-.224,2.492-.707,2.692-1.5a2.03,2.03,0,0,0-1.24-2.121,6.633,6.633,0,0,0-3.222-.393c.138-1.372-1.126-3-2.372-3.686a4.726,4.726,0,0,0-4.785.2c-.37-2.461-1.951-3.665-4.429-4.527a6.485,6.485,0,0,0-6.35,1.221c-1.435-2.686-5.714-4.294-10.109-2.536a7.625,7.625,0,0,0-3.963,3.707,8.523,8.523,0,0,0-.671,3.028,3.847,3.847,0,0,0-4.073-.2A3.161,3.161,0,0,0,54.1,23.157a8.125,8.125,0,0,0-2.637.611c-.953.4-1.942,1.3-1.6,2.235.262.712,1.147.994,1.926,1.1a11.739,11.739,0,0,0,4.637-.289,8.318,8.318,0,0,0,9.468-.229,15.383,15.383,0,0,0,1.958,1.264,7.708,7.708,0,0,0,2.275.609,6.16,6.16,0,0,0,4.231-.979.883.883,0,0,1,.494-.274.842.842,0,0,1,.421.146,6.154,6.154,0,0,0,6.478-.459,6.165,6.165,0,0,0,8.575-.347,6.808,6.808,0,0,0,3.775.567",
    transform: "translate(-18.761 -4.913)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_75356",
    "data-name": "Path 75356",
    d: "M196.015,168.041l57.937,35.175,27.5,7.393,36.631-13.58,32.72.085,16.35-20.545L350.8,121.233l-11.783-5.584L327.668,62.24l-44.242,1.549-8.213,28.95L262.034,96.7,249.327,121.83l-29.65,7.273Z",
    transform: "translate(-73.851 -23.45)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75357",
    "data-name": "Path 75357",
    d: "M338.838,226.573l-38.462,13.6-45.486-21.7,46.49,12.445Z",
    transform: "translate(-96.033 -82.314)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75358",
    "data-name": "Path 75358",
    d: "M331.129,274.37l-3.256-29.3,38.463-13.6,1.423,29.321Z",
    transform: "translate(-123.531 -87.209)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75359",
    "data-name": "Path 75359",
    d: "M429.506,177.2l9.266,55.578,16.35-20.546L438.772,156.9Z",
    transform: "translate(-161.822 -59.113)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75360",
    "data-name": "Path 75360",
    d: "M336.27,63.789l38.294,11.033,5.948-12.581Z",
    transform: "translate(-126.694 -23.45)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75362",
    "data-name": "Path 75362",
    d: "M386.327,147.937l-9.758,20.8-54.988,10.088,67.263-5,9.266-20.305Z",
    transform: "translate(-121.16 -55.737)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75363",
    "data-name": "Path 75363",
    d: "M415.011,115.649l-9.758,20.8-7.539-61.631,5.947-12.581Z",
    transform: "translate(-149.844 -23.45)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75364",
    "data-name": "Path 75364",
    d: "M233.983,165.127l29.65-7.273,12.4,18.021Z",
    transform: "translate(-88.156 -59.474)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75365",
    "data-name": "Path 75365",
    d: "M315.124,111.176l9.666,14.678,35.685,3.576-43.486,4.163-15.044-18.46Z",
    transform: "translate(-113.762 -41.887)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75366",
    "data-name": "Path 75366",
    d: "M162.582,257.942l41.867,17.34,36.907-13.744-.694-20.209-18.723-13.224-16.388-5.774-16.476-5.3-14.865,3.7Z",
    transform: "translate(-61.255 -81.771)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75367",
    "data-name": "Path 75367",
    d: "M225.93,234.8,219.192,251l-21.76,3.237L173.177,247.9l36.949,16.2,27.092-6.708,7.436-9.365Z",
    transform: "translate(-65.247 -88.463)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75368",
    "data-name": "Path 75368",
    d: "M229.758,289.969l1.685-17.879,27.092-6.708,7.436-9.365.694,20.208Z",
    transform: "translate(-86.565 -96.458)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75369",
    "data-name": "Path 75369",
    d: "M196.1,217.035l-14.865,3.7,16.558,6.1,14.783-4.5Z",
    transform: "translate(-68.284 -81.771)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75370",
    "data-name": "Path 75370",
    d: "M389.49,310.9l14.49,6.892V306.132l-9.542-5.655Z",
    transform: "translate(-146.746 -113.209)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75371",
    "data-name": "Path 75371",
    d: "M419.1,303.6l-6.361,3.711v11.663l9.542-4.594Z",
    transform: "translate(-155.505 -114.384)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75372",
    "data-name": "Path 75372",
    d: "M397.429,299.944l8.659-.884,7.245,2.828-6.361,3.711Z",
    transform: "translate(-149.737 -112.675)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75373",
    "data-name": "Path 75373",
    d: "M422.091,314.6l2.725,1.768,4.494-.884-3.02-1.4h-2.062Z",
    transform: "translate(-159.029 -118.334)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75374",
    "data-name": "Path 75374",
    d: "M425.283,323.1l.737-5.893,4.494-.884,1.179,2.947Z",
    transform: "translate(-160.231 -119.18)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75375",
    "data-name": "Path 75375",
    d: "M420.711,314.907l-2.284,6.63,4.272,1.031.737-5.893Z",
    transform: "translate(-157.648 -118.646)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75376",
    "data-name": "Path 75376",
    d: "M389.49,310.9l14.49,6.892V306.132l-9.542-5.655Z",
    transform: "translate(-146.746 -113.209)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75377",
    "data-name": "Path 75377",
    d: "M419.1,303.6l-6.361,3.711v11.663l9.542-4.594Z",
    transform: "translate(-155.505 -114.384)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75378",
    "data-name": "Path 75378",
    d: "M397.429,299.944l8.659-.884,7.245,2.828-6.361,3.711Z",
    transform: "translate(-149.737 -112.675)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75379",
    "data-name": "Path 75379",
    d: "M422.091,314.6l2.725,1.768,4.494-.884-3.02-1.4h-2.062Z",
    transform: "translate(-159.029 -118.334)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75380",
    "data-name": "Path 75380",
    d: "M425.283,323.1l.737-5.893,4.494-.884,1.179,2.947Z",
    transform: "translate(-160.231 -119.18)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75381",
    "data-name": "Path 75381",
    d: "M420.711,314.907l-2.284,6.63,4.272,1.031.737-5.893Z",
    transform: "translate(-157.648 -118.646)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46653",
    "data-name": "Group 46653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46652",
    "data-name": "Group 46652",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75382",
    "data-name": "Path 75382",
    d: "M255.3,71.188c-16.036,5.871-18.884,10.6-20.274,39.382a49.588,49.588,0,0,1-1.745,11.405c-2.861,9.922-9.124,15.793-19.083,21.246-21.377,11.723-22.081,25.883-22.243,35.637-.361,21.633-.249,39.133-30.476,62.105-25.54,19.414-54.365,34.054-65.957,65.857-21.427-4.9-41.5-12.365-58.833-22.374a146.875,146.875,0,0,1-16.584-11.069c13.7-26.737,59.151-42.972,80.84-49.5,22.58-6.806,55.163-16.354,61.034-44.742,4.313-20.866,3.833-31.48,38.541-48.862,7.778-3.9,12.889-7.952,16.372-12.1,9.324-11.106,6.949-22.885,12.814-34.128a24.647,24.647,0,0,1,15.749-12.851Z",
    transform: "translate(-7.576 -26.821)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46699",
    "data-name": "Group 46699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46698",
    "data-name": "Group 46698",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75404",
    "data-name": "Path 75404",
    d: "M347.792,20.268l-.031,28.655c-.006.3.77.313.782.006l.031-28.579Z",
    transform: "translate(-131.024 -7.636)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75405",
    "data-name": "Path 75405",
    d: "M348.637,20.125a.526.526,0,1,1-.4-.624.525.525,0,0,1,.4.624",
    transform: "translate(-130.962 -7.343)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75406",
    "data-name": "Path 75406",
    d: "M339.057,20.869c-2.408,2.871-5.821,1.589-8.637,1.421-3.051-.183-4.907.8-5.832,2.141a6.744,6.744,0,0,1,4.131.634s-3.108,2.032-3.112,5.36c.9-1.41,2.478-2.472,5.523-1.847,2.674.55,6.06,1.78,7.918-.279Z",
    transform: "translate(-122.293 -7.863)",
    fill: "#26a7df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46688",
    "data-name": "Group 46688",
    transform: "translate(203.314 13.006)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46687",
    "data-name": "Group 46687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46686",
    "data-name": "Group 46686",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75407",
    "data-name": "Path 75407",
    d: "M336.7,28.3c-2.458.745-9.157-2.522-10.478,2.12.9-1.41,2.478-2.472,5.524-1.847,2.674.55,6.06,1.78,7.917-.279l.009-7.431c-.011,2.924-.514,6.69-2.972,7.436",
    transform: "translate(-326.223 -20.869)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_75408",
    "data-name": "Path 75408",
    d: "M338.479,25.366l.423,1.285,1.341.181a.091.091,0,0,1,.041.163l-1.092.8.242,1.331a.09.09,0,0,1-.141.089l-1.1-.792-1.19.642a.09.09,0,0,1-.129-.107l.414-1.288-.978-.934a.091.091,0,0,1,.062-.156l1.352,0,.586-1.219a.09.09,0,0,1,.167.011",
    transform: "translate(-126.699 -9.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75409",
    "data-name": "Path 75409",
    d: "M305.837,57.737,305.8,95.5c-.008.394,1.015.414,1.03.007l.041-37.659Z",
    transform: "translate(-115.213 -21.753)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75410",
    "data-name": "Path 75410",
    d: "M306.952,57.548a.693.693,0,1,1-.533-.823.694.694,0,0,1,.533.823",
    transform: "translate(-115.132 -21.366)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75411",
    "data-name": "Path 75411",
    d: "M294.328,58.529c-3.172,3.783-7.671,2.094-11.381,1.872-4.021-.24-6.467,1.058-7.685,2.821,1.16-.308,4.418-.015,5.444.836,0,0-4.1,2.677-4.1,7.064,1.192-1.858,3.265-3.258,7.278-2.433,3.524.724,7.986,2.345,10.433-.368Z",
    transform: "translate(-103.709 -22.052)",
    fill: "#5cae48"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46691",
    "data-name": "Group 46691",
    transform: "translate(172.896 36.477)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46690",
    "data-name": "Group 46690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46689",
    "data-name": "Group 46689",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75412",
    "data-name": "Path 75412",
    d: "M291.224,68.328c-3.239.982-12.066-3.323-13.807,2.794,1.192-1.858,3.265-3.258,7.278-2.433,3.524.724,7.986,2.345,10.433-.368l.012-9.792c-.014,3.854-.677,8.816-3.916,9.8",
    transform: "translate(-277.417 -58.528)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_75413",
    "data-name": "Path 75413",
    d: "M249.279,95.205l-.05,46.862c-.011.489,1.26.514,1.278.009l.05-46.74Z",
    transform: "translate(-93.9 -35.87)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75414",
    "data-name": "Path 75414",
    d: "M250.661,94.972A.86.86,0,1,1,250,93.95a.861.861,0,0,1,.661,1.021",
    transform: "translate(-93.799 -35.39)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75415",
    "data-name": "Path 75415",
    d: "M234.994,96.188c-3.938,4.695-9.521,2.6-14.126,2.324-4.989-.3-8.025,1.312-9.537,3.5,1.44-.383,5.483-.019,6.757,1.037,0,0-5.084,3.322-5.089,8.767,1.479-2.307,4.052-4.044,9.033-3.02,4.375.9,9.911,2.911,12.948-.456Z",
    transform: "translate(-79.622 -36.24)",
    fill: "#d42941"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46694",
    "data-name": "Group 46694",
    transform: "translate(133.376 59.948)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46693",
    "data-name": "Group 46693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46692",
    "data-name": "Group 46692",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75416",
    "data-name": "Path 75416",
    d: "M231.141,108.349c-4.02,1.219-14.976-4.124-17.135,3.468,1.479-2.307,4.052-4.044,9.033-3.02,4.375.9,9.911,2.911,12.948-.456L236,96.188c-.017,4.783-.841,10.942-4.861,12.161",
    transform: "translate(-214.005 -96.188)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_75417",
    "data-name": "Path 75417",
    d: "M190.177,133.623l-.06,55.967c-.012.584,1.5.613,1.527.011l.06-55.82Z",
    transform: "translate(-71.629 -50.344)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75418",
    "data-name": "Path 75418",
    d: "M191.829,133.345a1.027,1.027,0,1,1-.79-1.22,1.028,1.028,0,0,1,.79,1.22",
    transform: "translate(-71.508 -49.771)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75419",
    "data-name": "Path 75419",
    d: "M173.117,134.8c-4.7,5.607-11.37,3.1-16.87,2.775-5.959-.356-9.584,1.567-11.39,4.181,1.72-.457,6.547-.023,8.069,1.238,0,0-6.072,3.968-6.078,10.47,1.766-2.754,4.84-4.829,10.788-3.606,5.224,1.073,11.837,3.476,15.464-.545Z",
    transform: "translate(-54.577 -50.787)",
    fill: "#f8b018"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46697",
    "data-name": "Group 46697",
    transform: "translate(92.271 84.01)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46696",
    "data-name": "Group 46696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46695",
    "data-name": "Group 46695",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75420",
    "data-name": "Path 75420",
    d: "M168.516,149.321c-4.8,1.456-17.886-4.925-20.465,4.141,1.766-2.755,4.84-4.829,10.788-3.607,5.224,1.074,11.837,3.476,15.464-.545l.017-14.514c-.021,5.713-1,13.068-5.8,14.524",
    transform: "translate(-148.051 -134.797)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46799",
    "data-name": "Group 46799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46798",
    "data-name": "Group 46798",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46797",
    "data-name": "Group 46797",
    transform: "translate(32.539 223.897)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46796",
    "data-name": "Group 46796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46795",
    "data-name": "Group 46795",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75466",
    "data-name": "Path 75466",
    d: "M108.443,364.82c12.864,7.427,12.864,19.469,0,26.9s-33.721,7.427-46.586,0-12.864-19.469,0-26.9,33.721-7.427,46.586,0",
    transform: "translate(-52.209 -359.249)",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46807",
    "data-name": "Group 46807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46806",
    "data-name": "Group 46806",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75467",
    "data-name": "Path 75467",
    d: "M62.1,225.514l4.918-12.507-.76-15.385c-3.122.258-5.311,1.392-6.959,5.253s-4.95,16.3-5.58,19.2a26.288,26.288,0,0,0-.568,7.67c.151,3.28,1.59,9.21,2.134,12.438.251,1.493.384,2.936.532,4.456a34.379,34.379,0,0,0,1.084,4.618,4.274,4.274,0,0,0,1.123,1.93c.339.344.828.417,1.151.74s.365.838.826,1.117c.512.311,1.14.193,1.584.507a13.758,13.758,0,0,0,1.366,1.061,2.967,2.967,0,0,1,1.164.807c.277.361.511,1.133,1.066,1.124.622-.011.77-.6.845-1.113a4.736,4.736,0,0,0-.753-2.859,26.838,26.838,0,0,0-1.571-2.7,6.587,6.587,0,0,1-1.1-2.718c-.142-.653-.016-1.465.777-1.025.934.519,1.884,1.528,3.063,1.424.815-.072.912-.7.486-1.27a23.564,23.564,0,0,1-1.885-2.954c-.568-1.048-1.019-2.147-1.615-3.176a14.33,14.33,0,0,0-1.073-1.544c-1.068-1.38-.878-3.127-.878-4.765,0-2.287.419-7.4.624-10.32",
    transform: "translate(-20.002 -74.457)",
    fill: "#c8856a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75468",
    "data-name": "Path 75468",
    d: "M66.1,196.241c-4.54.395-6.8,3.279-8.338,7.83-1.578,4.664-3.891,13.029-4.358,15.249a31.048,31.048,0,0,0-.954,8.187,76.947,76.947,0,0,0,1.167,8.725,7.492,7.492,0,0,0,3.721.678c3.536-.054,4.237-1.127,4.237-1.127l.6-10.734,4.966-12.4Z",
    transform: "translate(-19.756 -73.937)",
    fill: "#f8b018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75469",
    "data-name": "Path 75469",
    d: "M68.637,378.624c0,.8-.149,1.114.835,1.839a6.362,6.362,0,0,0,4.74.622,4.371,4.371,0,0,0,2.62-1.582,21.27,21.27,0,0,0,1.522-2.294,11.307,11.307,0,0,1,2.877-1.621c1.34-.6,3.91-1.781,4.83-3.957a5.173,5.173,0,0,0,.285-3.732Z",
    transform: "translate(-25.857 -138.611)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75470",
    "data-name": "Path 75470",
    d: "M77.087,366.079c-2.6,1.7-4.78,5.953-8.331,4.66-.178,2.084-.732,4.332-.237,6.381a5.358,5.358,0,0,0,6.736.883c.96-.818,1.5-1.778,2.428-2.643a9.294,9.294,0,0,1,2.553-1.556,27.033,27.033,0,0,0,3.089-1.71c5.738-4.231,2.891-11.978-6.238-6.014",
    transform: "translate(-25.74 -137.106)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75471",
    "data-name": "Path 75471",
    d: "M97.073,400.754c0,.869.057,1.524.59,1.893a31.047,31.047,0,0,0,5.571,1.146c1.059.123,1.212-.573,1.954-.328a23.358,23.358,0,0,0,5.065,2.087c2.593.573,4.721,1.187,8.323,0s3.957-2.581,3.91-3.8-25.412-1-25.412-1",
    transform: "translate(-36.574 -150.984)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75472",
    "data-name": "Path 75472",
    d: "M97.415,387.151c-.58,2.495-1.2,6.23-.52,8.129.724.719,3.158,1.142,5.279,1.428a16.315,16.315,0,0,1,5.613,1.748c4.117,1.718,11.357,2.344,14.242-1.532,2.88-5.174-12.109-3.9-13.947-9.889-.669-2.179-7.946.7-10.667.116",
    transform: "translate(-36.395 -145.509)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75473",
    "data-name": "Path 75473",
    d: "M66.687,307c2-21.273.97-38.272,2.881-55.4,0,0,29.875-.744,30.61,9.4,0,0,.454,36.174.219,40.644-.106,4.529-2.819,32.77-2.819,35.963-7.422,3.683-12.022.9-12.022.9.047-4.12-3.176-20.133-1.429-30.181l-1.186-17.056s-5.093,30.547-5.953,38.786c-2.193,3.249-8.411,2.491-9.448.529,0,0-1.556-17.327-.853-23.59",
    transform: "translate(-25.056 -94.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75478",
    "data-name": "Path 75478",
    d: "M95.069,191.233l-1.2,7.22-10.616.092,1.687-7.779Z",
    transform: "translate(-31.367 -71.874)",
    fill: "#c8856a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75479",
    "data-name": "Path 75479",
    d: "M107.361,170.912c.785.946,3.228,3.8,3.332,4.357l-1.9,1.233Z",
    transform: "translate(-40.45 -64.394)",
    fill: "#af6152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75480",
    "data-name": "Path 75480",
    d: "M89.674,159.366c3.048-.409,5.086,1.706,6.146,8.186.042.254.429.644.74,1.61,1.334,4.143.753,8.135.075,9.211a8.525,8.525,0,0,1-6.546,1.885c-2.178-.128-7.738-.643-10.626-3.5-3.4-3.365-5.2-8.524-2.925-11.286,3.2-3.886,11.457-5.878,13.136-6.1",
    transform: "translate(-28.455 -60.025)",
    fill: "#c8856a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75481",
    "data-name": "Path 75481",
    d: "M106.594,189.893a7.178,7.178,0,0,1-4.641,1.963l.161-1.148a15.328,15.328,0,0,0,4.479-.815",
    transform: "translate(-38.412 -71.545)",
    fill: "#af6152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75482",
    "data-name": "Path 75482",
    d: "M89.386,168.229a.556.556,0,0,1-.993.191,7.4,7.4,0,0,0-1.122-1.234,2.723,2.723,0,0,0-1.862-.575c-2.5.256-1.8,3.541-.542,4.657,2.062,1.827,3.089.175,3.089.175s1.528,3.154-.529,5.075c0,0-3.764,1.081-6.643.269-2.2-2.246-3.5-3.074-4.984-5.016-3.526-4.6-4.126-10.476-1.978-11.861-.166-1.662.669-4.188,4.05-5.723a15.224,15.224,0,0,1,7.765-1.314c2.359.069,5.283,1.068,7.421-.817a4.475,4.475,0,0,1-.255,4.09,1.48,1.48,0,0,1,1.348,2.633,1.162,1.162,0,0,1,.569,1.365,1.412,1.412,0,0,1-1.2.937,5.963,5.963,0,0,1-1.483-.055,4.229,4.229,0,0,1-4.082,2.624,5.2,5.2,0,0,1,1.431,4.579",
    transform: "translate(-27.343 -57.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75483",
    "data-name": "Path 75483",
    d: "M95.71,199.836c-2.212-1.992-1.544-2.1-2.98-3.28-1.786-1.468-9.6-3.3-10.23-2.658a8.517,8.517,0,0,1-2.307,1.71s.371,1.2,5.089,2.341c4.5,1.089,6.278.938,10.427,1.887",
    transform: "translate(-30.214 -73.005)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75484",
    "data-name": "Path 75484",
    d: "M76.585,195.256c2.6.435,7.281,1.7,9.746,2.37a26.311,26.311,0,0,1,5.839,2.906s4.734,2.059,5.318,2.707,1.772,3.633,2.249,10.119.858,31.094.858,31.094-1.817.542-3.132.764l-.9-7.382-1,7.741a70.679,70.679,0,0,1-16.367-.952,17.944,17.944,0,0,1-10.768-6.357s1.111-13.1.815-15.762-2.631-13.882-2.372-18.293,1.94-7.939,4.664-8.343c3.317-.492,5.051-.614,5.051-.614",
    transform: "translate(-25.187 -73.565)",
    fill: "#f8b018"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75485",
    "data-name": "Path 75485",
    d: "M80.442,197.416c.674.264,1.366.469,2.061.669s1.387.4,2.085.593c1.394.378,2.788.758,4.188,1.1,1.4.361,2.807.621,4.233.866l4.282.7c-1.448-.07-2.89-.209-4.328-.387a33.9,33.9,0,0,1-4.285-.78c-1.407-.357-2.8-.749-4.18-1.2a28.536,28.536,0,0,1-4.055-1.562",
    transform: "translate(-30.308 -74.379)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75496",
    "data-name": "Path 75496",
    d: "M130.861,272.569a43.842,43.842,0,0,1-1.241-5.479,72.957,72.957,0,0,1-.423-7.535l-8.31,2.126a52.692,52.692,0,0,1,1.309,5.333c.353,1.943-.343,3.7-.33,5.62a4.416,4.416,0,0,0,.674,2.453c.259.383.6.707.853,1.091.5.755.485,1.289-.267,1.718a.936.936,0,0,0-.385.9,1.891,1.891,0,0,0,.9.577,1.677,1.677,0,0,0,.455.069c.157,0,.337-.078.484-.066s.3.122.474.133a2.077,2.077,0,0,0,.522-.053,1.706,1.706,0,0,0,.9-.372c.234-.232.33-.593.606-.775.377-.25.879-.047,1.331-.076a1.292,1.292,0,0,0,1.061-.718,1.553,1.553,0,0,1,.334-.6c.188-.15.455-.137.678-.226a1.049,1.049,0,0,0,.553-.617,5.683,5.683,0,0,0-.179-3.5",
    transform: "translate(-45.545 -97.791)",
    fill: "#c8856a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75497",
    "data-name": "Path 75497",
    d: "M115.92,208.236c2.191,1.106,2.743,1.558,3.944,4.006s2.8,9.155,3.258,13.191,1.651,7.912,1.943,12.019.257,7.417.257,7.417a10.2,10.2,0,0,1-3.8,1.078,12.691,12.691,0,0,1-3.985,0s-3.071-11.331-3.868-14.43S110,220,110,220c-.965-5.471.371-11.63,1.873-13.618,0,0,1.854.742,4.045,1.849",
    transform: "translate(-41.321 -77.759)",
    fill: "#f8b018"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46812",
    "data-name": "Group 46812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46811",
    "data-name": "Group 46811",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75498",
    "data-name": "Path 75498",
    d: "M96.89,101.494a13.771,13.771,0,0,1-3.709,9.431l-1.142,1.088A13.785,13.785,0,0,1,72.563,92.625l1.088-1.144A13.785,13.785,0,0,1,96.89,101.494",
    transform: "translate(-26.108 -33.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75499",
    "data-name": "Path 75499",
    d: "M82.352,85.851a14.965,14.965,0,0,0-2.424,29.726l1.69,4.332a.869.869,0,0,0,1.621,0l1.671-4.34a14.964,14.964,0,0,0-2.558-29.715m13.831,14.936a13.771,13.771,0,0,1-3.709,9.431l-1.142,1.088A13.785,13.785,0,0,1,71.856,91.918l1.088-1.144a13.785,13.785,0,0,1,23.239,10.013",
    transform: "translate(-25.401 -32.346)",
    fill: "#5cae48"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46810",
    "data-name": "Group 46810",
    transform: "translate(43.188 54.675)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46809",
    "data-name": "Group 46809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46808",
    "data-name": "Group 46808",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75500",
    "data-name": "Path 75500",
    d: "M96.89,101.494a13.771,13.771,0,0,1-3.709,9.431l-1.142,1.088A13.785,13.785,0,0,1,72.563,92.625l1.088-1.144A13.785,13.785,0,0,1,96.89,101.494",
    transform: "translate(-69.296 -87.727)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_75501",
    "data-name": "Path 75501",
    d: "M87.155,97.7l1.9,4.713,5.069.348a.339.339,0,0,1,.194.6l-3.9,3.261,1.235,4.928a.339.339,0,0,1-.509.37l-4.306-2.7-4.305,2.7a.339.339,0,0,1-.509-.37l1.235-4.928-3.9-3.261a.339.339,0,0,1,.194-.6l5.069-.348,1.9-4.713a.339.339,0,0,1,.629,0",
    transform: "translate(-29.856 -36.731)",
    fill: "#5cae48"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.1372fa95ccb821c0cb8d1fc4a423ea46.svg";
export { ForwardRef as ReactComponent };